var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          { staticStyle: { display: "flex", padding: "8px 16px 0 16px" } },
          [
            _c(
              "div",
              { staticClass: "filters" },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      inline: true,
                      "label-width": "80px",
                      "label-position": "left"
                    },
                    nativeOn: {
                      submit: function($event) {
                        $event.preventDefault()
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "el-form-item-wrapper" },
                      [
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "div",
                              {
                                staticStyle: { "text-align": "center" },
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.opOffice")))]
                            ),
                            _c("cargo-advance-select", {
                              staticStyle: { width: "230px" },
                              attrs: {
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Office_All,
                                filterable: "",
                                multiple: true,
                                "default-multiple-value":
                                  _vm.from.multipleOfficeIdList || [],
                                "tag-name": "code"
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.from.multipleOfficeIdList = p.value
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "div",
                              {
                                staticStyle: { "text-align": "center" },
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("CargoMsg.Cargo_BusinessType"))
                                )
                              ]
                            ),
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "230px" },
                                attrs: { clearable: "" },
                                on: { change: _vm.multipleLobChange },
                                model: {
                                  value: _vm.from.lob,
                                  callback: function($$v) {
                                    _vm.$set(_vm.from, "lob", $$v)
                                  },
                                  expression: "from.lob"
                                }
                              },
                              _vm._l(_vm.lobs, function(item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    value: item.code,
                                    label: item.chineseName
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "div",
                              {
                                staticStyle: { "text-align": "center" },
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SystemMaintenance.PushingLink")
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "230px" },
                                attrs: { clearable: "" },
                                model: {
                                  value: _vm.from.pushLink,
                                  callback: function($$v) {
                                    _vm.$set(_vm.from, "pushLink", $$v)
                                  },
                                  expression: "from.pushLink"
                                }
                              },
                              _vm._l(_vm.pushFilterList, function(item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: { value: item.id, label: item.name }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "div",
                              {
                                staticStyle: { "text-align": "center" },
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("CargoMsg.Cargo_Recipient"))
                                )
                              ]
                            ),
                            _c("cargo-advance-select", {
                              staticStyle: { width: "230px" },
                              attrs: {
                                "select-type":
                                  _vm.selectTypeNames
                                    .local_cache_SystemConstants$LOBS,
                                filterable: "",
                                multiple: true,
                                "static-options": _vm.accountList,
                                "default-multiple-value":
                                  _vm.from.multipleAccountIdList || [],
                                "tag-name": _vm.isZh
                                  ? "chineseName"
                                  : "englishName",
                                "tag-value": "code"
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.from.multipleAccountIdList = p.value
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "triggers" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.getListData }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Query")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "primary",
                      disabled: !_vm.$checkPermission([
                        "role_emailTemplate_add"
                      ])
                    },
                    on: { click: _vm.toAdd }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_NewTo")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "primary",
                      disabled: !_vm.$checkPermission([
                        "role_emailTemplate_editable"
                      ])
                    },
                    on: { click: _vm.toView }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "danger",
                      disabled: !_vm.$checkPermission([
                        "role_emailTemplate_delete"
                      ])
                    },
                    on: { click: _vm.toDelete }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_OrderDelete")))]
                )
              ],
              1
            )
          ]
        ),
        _c("div", { staticClass: "main-content" }, [
          _c(
            "div",
            { staticClass: "section grid-wrapper" },
            [
              _c("cargo-ag-grid", {
                attrs: {
                  "config-module": "195625",
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData
                }
              })
            ],
            1
          )
        ])
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.emailEditingAccording,
            "close-on-click-modal": false,
            title: _vm.$t("SystemMaintenance.EmailTemplateEditing"),
            width: "1100px"
          },
          on: {
            "update:visible": function($event) {
              _vm.emailEditingAccording = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.emailEditing,
                "label-width": "120px",
                "label-position": "right"
              }
            },
            [
              _c(
                "div",
                { staticClass: "el-form-item-wrapper" },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "padding-bottom": "10px" }
                    },
                    [
                      _c("span", {
                        staticClass: "edit-email-title",
                        staticStyle: { top: "57px" }
                      }),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "padding-left": "40px",
                            "font-size": "15px"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "CargoMsg.Cargo_BusinessApplicationContext"
                              )
                            )
                          )
                        ]
                      )
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "padding-left": "41px",
                        "border-bottom": "1px solid #E3E3E3",
                        "padding-bottom": "10px"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { "label-width": "80px" } },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: { "text-align": "center" },
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.opOffice")))]
                          ),
                          _c("cargo-advance-select", {
                            staticStyle: { width: "150px" },
                            attrs: {
                              "select-type":
                                _vm.selectTypeNames.basic_data_Office_All,
                              filterable: "",
                              multiple: true,
                              "default-multiple-value":
                                _vm.emailEditing.multipleOfficeIdList || [],
                              "tag-name": "code"
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.emailEditing.multipleOfficeIdList = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { "label-width": "80px" } },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: { "text-align": "center" },
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_BusinessType"))
                              )
                            ]
                          ),
                          _c(
                            "el-select",
                            {
                              attrs: { clearable: "" },
                              on: { change: _vm.lobChange },
                              model: {
                                value: _vm.emailEditing.lob,
                                callback: function($$v) {
                                  _vm.$set(_vm.emailEditing, "lob", $$v)
                                },
                                expression: "emailEditing.lob"
                              }
                            },
                            _vm._l(_vm.lobs, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  value: item.code,
                                  label: item.chineseName
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { "label-width": "80px" } },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: { "text-align": "center" },
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SystemMaintenance.PushingLink"))
                              )
                            ]
                          ),
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "150px" },
                              attrs: { clearable: "" },
                              on: { change: _vm.pushListChange },
                              model: {
                                value: _vm.emailEditing.pushLink,
                                callback: function($$v) {
                                  _vm.$set(_vm.emailEditing, "pushLink", $$v)
                                },
                                expression: "emailEditing.pushLink"
                              }
                            },
                            _vm._l(_vm.pushList, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { value: item.id, label: item.name }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { "label-width": "80px" } },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: { "text-align": "center" },
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Recipient")))]
                          ),
                          _c("cargo-advance-select", {
                            staticStyle: { width: "166px" },
                            attrs: {
                              "select-type":
                                _vm.selectTypeNames
                                  .local_cache_SystemConstants$LOBS,
                              filterable: "",
                              disabled:
                                _vm.emailEditing.pushLink === "16" ||
                                _vm.emailEditing.pushLink === "17" ||
                                _vm.isBbSendDestinationPortAgent,
                              multiple: true,
                              "static-options": _vm.accountList,
                              "default-multiple-value":
                                _vm.emailEditing.multipleAccountIdList || [],
                              "tag-name": _vm.isZh
                                ? "chineseName"
                                : "englishName",
                              "tag-value": "code"
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.emailEditing.multipleAccountIdList = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "padding-top": "15px",
                        "padding-bottom": "10px"
                      }
                    },
                    [
                      _c("span", {
                        staticClass: "edit-email-title",
                        staticStyle: { top: "145px" }
                      }),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "padding-left": "40px",
                            "font-size": "15px"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("CargoMsg.Cargo_ConfigureEmailTemplate")
                            )
                          )
                        ]
                      ),
                      ["19", "20", "21"].includes(_vm.emailEditing.pushLink)
                        ? _c(
                            "span",
                            {
                              staticStyle: {
                                "padding-left": "10px",
                                "font-size": "14px"
                              }
                            },
                            [
                              _c("el-tooltip", [
                                _c("i", {
                                  staticClass: "el-icon-warning",
                                  staticStyle: {
                                    color: "#e6a23c",
                                    "margin-left": "5px"
                                  }
                                })
                              ]),
                              _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "SystemMaintenance.SendEmailByPositionPersonnel"
                                    )
                                  )
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label:
                          _vm.$t("CargoMsg.Cargo_Email2") +
                          _vm.$t("Template.TemplateName")
                      }
                    },
                    [
                      _c("el-input", {
                        ref: "templateName",
                        model: {
                          value: _vm.emailEditing.templateName,
                          callback: function($$v) {
                            _vm.$set(_vm.emailEditing, "templateName", $$v)
                          },
                          expression: "emailEditing.templateName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("CargoMsg.Cargo_SendingPosition") }
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.emailEditing.sales,
                            callback: function($$v) {
                              _vm.$set(_vm.emailEditing, "sales", $$v)
                            },
                            expression: "emailEditing.sales"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Sales")))]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.emailEditing.op,
                            callback: function($$v) {
                              _vm.$set(_vm.emailEditing, "op", $$v)
                            },
                            expression: "emailEditing.op"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Operation")))]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.emailEditing.csr,
                            callback: function($$v) {
                              _vm.$set(_vm.emailEditing, "csr", $$v)
                            },
                            expression: "emailEditing.csr"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.CustomerService")))]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.emailEditing.doc,
                            callback: function($$v) {
                              _vm.$set(_vm.emailEditing, "doc", $$v)
                            },
                            expression: "emailEditing.doc"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Documents")))]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "siteOP" },
                          model: {
                            value: _vm.emailEditing.siteOP,
                            callback: function($$v) {
                              _vm.$set(_vm.emailEditing, "siteOP", $$v)
                            },
                            expression: "emailEditing.siteOP"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.FieldOperation")))]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "overseaOp" },
                          model: {
                            value: _vm.emailEditing.overseaOp,
                            callback: function($$v) {
                              _vm.$set(_vm.emailEditing, "overseaOp", $$v)
                            },
                            expression: "emailEditing.overseaOp"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("SeaExport.OverseaCustomerService"))
                          )
                        ]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "planner" },
                          model: {
                            value: _vm.emailEditing.planner,
                            callback: function($$v) {
                              _vm.$set(_vm.emailEditing, "planner", $$v)
                            },
                            expression: "emailEditing.planner"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.AirlinePerson2")))]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "userDefinedRoleId1" },
                          model: {
                            value: _vm.emailEditing.userDefinedRoleId1,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.emailEditing,
                                "userDefinedRoleId1",
                                $$v
                              )
                            },
                            expression: "emailEditing.userDefinedRoleId1"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_userDefinedRole1"))
                          )
                        ]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "userDefinedRoleId2" },
                          model: {
                            value: _vm.emailEditing.userDefinedRoleId2,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.emailEditing,
                                "userDefinedRoleId2",
                                $$v
                              )
                            },
                            expression: "emailEditing.userDefinedRoleId2"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_userDefinedRole2"))
                          )
                        ]
                      ),
                      !["19", "20", "21"].includes(_vm.emailEditing.pushLink)
                        ? _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.emailEditing.emailGroup,
                                callback: function($$v) {
                                  _vm.$set(_vm.emailEditing, "emailGroup", $$v)
                                },
                                expression: "emailEditing.emailGroup"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.EmailGroup")))]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm.emailEditing.emailGroup
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label:
                              _vm.$t("SeaExport.Cc") +
                              _vm.$t("SeaExport.EmailGroup")
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                filterable: "",
                                multiple: "",
                                clearable: ""
                              },
                              model: {
                                value: _vm.emailEditing.emailGroupCcList,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.emailEditing,
                                    "emailGroupCcList",
                                    $$v
                                  )
                                },
                                expression: "emailEditing.emailGroupCcList"
                              }
                            },
                            _vm._l(_vm.emailGroupCcList, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.groupName,
                                  value: item.uuid
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.emailSubject") } },
                    [
                      _c("el-input", {
                        ref: "themeTemplate",
                        on: {
                          focus: function($event) {
                            _vm.eFocus = _vm.constant.eFocus.emailTitle
                          },
                          blur: _vm.blurEvent
                        },
                        model: {
                          value: _vm.emailEditing.themeTemplate,
                          callback: function($$v) {
                            _vm.$set(_vm.emailEditing, "themeTemplate", $$v)
                          },
                          expression: "emailEditing.themeTemplate"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SystemMaintenance.TextTemplate") }
                    },
                    [
                      _c("cargo-editor", {
                        staticStyle: { height: "400px" },
                        attrs: {
                          placeholder: _vm.$t(
                            "SystemMaintenance.PleaseAProductDescriptionHere"
                          )
                        },
                        on: {
                          onCreated: function(p) {
                            _vm.editor = p
                          }
                        },
                        model: {
                          value: _vm.emailEditing.contentTemplate,
                          callback: function($$v) {
                            _vm.$set(_vm.emailEditing, "contentTemplate", $$v)
                          },
                          expression: "emailEditing.contentTemplate"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SystemMaintenance.DataItem") } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "margin-bottom": "10px",
                            width: "66%"
                          }
                        },
                        [
                          _c(
                            "div",
                            { ref: "dataItemTabs", staticClass: "outside" },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: { position: "relative" },
                                  on: { click: _vm.spread }
                                },
                                [
                                  _c("div", { staticClass: "outside-value" }, [
                                    _vm._v(_vm._s(_vm.showName))
                                  ]),
                                  _c("i", {
                                    staticClass: "el-icon-arrow-down icon",
                                    class: {
                                      rotatingShow: _vm.isShow,
                                      rotatingHide: !_vm.isShow
                                    }
                                  })
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.isShow,
                                      expression: "isShow"
                                    }
                                  ],
                                  staticClass: "operation",
                                  staticStyle: { "z-index": "100" }
                                },
                                _vm._l(_vm.dataItemTabs, function(item, index) {
                                  return _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.code ===
                                            _vm.SE_FILE_INFORMATION.code
                                              ? _vm.emailEditing.pushLink ===
                                                  "16" ||
                                                _vm.emailEditing.pushLink ===
                                                  "17" ||
                                                _vm.isBbSendDestinationPortAgent
                                              : true,
                                          expression:
                                            "item.code===SE_FILE_INFORMATION.code?emailEditing.pushLink==='16'||emailEditing.pushLink==='17'||isBbSendDestinationPortAgent:true"
                                        }
                                      ],
                                      key: index,
                                      staticClass: "item",
                                      class: {
                                        "set-color": _vm.value === item.code,
                                        "set-bgc": index === 0
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.selectItem(item)
                                        }
                                      }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.isZh
                                              ? item.chineseName
                                              : item.englishName
                                          )
                                        )
                                      ]),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.dataItemTab === item.code,
                                              expression:
                                                "dataItemTab === item.code"
                                            }
                                          ],
                                          staticClass: "dataItem"
                                        },
                                        _vm._l(_vm.dataItems, function(
                                          item,
                                          itemIndex
                                        ) {
                                          return _c(
                                            "span",
                                            {
                                              key: itemIndex,
                                              staticClass: "item",
                                              class: {
                                                itemChoose:
                                                  _vm.chooseId === itemIndex
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.onClickSopDataItemByContent(
                                                    item.chineseName,
                                                    itemIndex
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v(_vm._s(item.chineseName))]
                                          )
                                        }),
                                        0
                                      )
                                    ]
                                  )
                                }),
                                0
                              )
                            ]
                          ),
                          _c("cargo-advance-select", {
                            staticStyle: { width: "320px" },
                            attrs: {
                              "static-options": _vm.dataItems,
                              placeholder: _vm.$t(
                                "CargoMsg.Cargo_SearchForTheDataYouWantToInsert"
                              ),
                              cache: false,
                              "filter-type": "global",
                              filterable: "",
                              clearable: "",
                              "tag-value": "chineseName"
                            },
                            on: {
                              parentCallBack: _vm.changeDataItem,
                              focus: _vm.dataItemFocusEvent
                            }
                          }),
                          _vm.emailEditing.pushLink === "16" ||
                          _vm.emailEditing.pushLink === "17" ||
                          _vm.isBbSendDestinationPortAgent
                            ? [
                                _c(
                                  "div",
                                  { staticStyle: { display: "flex" } },
                                  [
                                    _c("span", {
                                      staticClass: "edit-email-title",
                                      staticStyle: {
                                        left: "unset",
                                        top: "8px",
                                        "margin-left": "10px"
                                      }
                                    }),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { "padding-left": "20px" }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "SystemMaintenance.AutoPrintRule"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SystemMaintenance.MailServer") }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "320px" },
                          model: {
                            value: _vm.emailEditing.mailServerType,
                            callback: function($$v) {
                              _vm.$set(_vm.emailEditing, "mailServerType", $$v)
                            },
                            expression: "emailEditing.mailServerType"
                          }
                        },
                        _vm._l(_vm.mailServers, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { value: item.code, label: item.chineseName }
                          })
                        }),
                        1
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.emailEditing.mailServerType === 1,
                              expression: "emailEditing.mailServerType===1"
                            }
                          ],
                          staticStyle: {
                            "margin-left": "10px",
                            display: "inline-block"
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-warning",
                            staticStyle: {
                              color: "#E6A23C",
                              "font-size": "14px",
                              "margin-right": "5px",
                              "line-height": "18px"
                            }
                          }),
                          _c(
                            "span",
                            { staticStyle: { "line-height": "18px" } },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "SystemMaintenance.PushConfigServiceCompanyEmail"
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm.emailEditing.pushLink === "16" ||
                  _vm.emailEditing.pushLink === "17"
                    ? [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "SystemMaintenance.MainTicketAttachmentItem"
                              )
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "start"
                                }
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: {
                                      width: "100px",
                                      "margin-right": "10px",
                                      "border-radius": "5px"
                                    },
                                    attrs: { type: "primary" },
                                    on: { click: _vm.onMasterSelectFileType }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "SystemMaintenance.SelectFileType"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c("el-input", {
                                  staticStyle: {
                                    width: "320px",
                                    "margin-right": "10px"
                                  },
                                  attrs: {
                                    value: _vm.masterFileCategoryLabel,
                                    disabled: "",
                                    type: "textarea",
                                    rows: 3
                                  }
                                }),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "100px",
                                      "margin-top": "-7px"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-checkbox",
                                      {
                                        staticStyle: { "margin-top": "-7px" },
                                        on: {
                                          change: _vm.onAutoGenerationManifest
                                        },
                                        model: {
                                          value:
                                            _vm.emailEditing
                                              .autoGenerationManifest,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.emailEditing,
                                              "autoGenerationManifest",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "emailEditing.autoGenerationManifest"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "SystemMaintenance.AutoGenerationManifestLabel"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-checkbox",
                                      {
                                        staticClass: "checkbox-multiple",
                                        staticStyle: { "margin-top": "-7px" },
                                        attrs: {
                                          disabled: !_vm.emailEditing
                                            .autoGenerationManifest
                                        },
                                        model: {
                                          value:
                                            _vm.emailEditing
                                              .autoPrintManifestAfterAllHblConfirm,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.emailEditing,
                                              "autoPrintManifestAfterAllHblConfirm",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "emailEditing.autoPrintManifestAfterAllHblConfirm"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "SystemMaintenance.TheStatusOfAllProcesses"
                                              )
                                            ) +
                                            " "
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "SystemMaintenance.WhenOnlyAfterTheConfirmed"
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-checkbox",
                                      {
                                        staticStyle: { "margin-top": "-7px" },
                                        on: {
                                          change:
                                            _vm.onHblWithoutGenerateAttachChange
                                        },
                                        model: {
                                          value:
                                            _vm.emailEditing
                                              .hblWithoutGenerateAttach,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.emailEditing,
                                              "hblWithoutGenerateAttach",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "emailEditing.hblWithoutGenerateAttach"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "SystemMaintenance.HblWithoutGenerateAttachLabel"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-checkbox",
                                      {
                                        staticStyle: { "margin-top": "-7px" },
                                        model: {
                                          value:
                                            _vm.emailEditing.confirmedPrintHbl,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.emailEditing,
                                              "confirmedPrintHbl",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "emailEditing.confirmedPrintHbl"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "SystemMaintenance.ConfirmedPrintHblLabel"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "SystemMaintenance.SmallTicketAttachmentItem"
                              )
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "start"
                                }
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: {
                                      width: "100px",
                                      "margin-right": "10px",
                                      "border-radius": "5px"
                                    },
                                    attrs: { type: "primary" },
                                    on: { click: _vm.onSalveSelectFileType }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "SystemMaintenance.SelectFileType"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c("el-input", {
                                  staticStyle: {
                                    width: "320px",
                                    "margin-right": "10px"
                                  },
                                  attrs: {
                                    value: _vm.slaveFileCategoryLabel,
                                    disabled: "",
                                    type: "textarea",
                                    rows: 4
                                  }
                                }),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "150px",
                                      "margin-top": "-7px"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticStyle: { display: "flex" } },
                                      [
                                        _c("span", {
                                          staticClass: "edit-email-title",
                                          staticStyle: {
                                            left: "unset",
                                            top: "0"
                                          }
                                        }),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "padding-left": "10px"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "SystemMaintenance.EmailAttachRule"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-checkbox",
                                      {
                                        model: {
                                          value:
                                            _vm.emailEditing.includeSlaveAttach,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.emailEditing,
                                              "includeSlaveAttach",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "emailEditing.includeSlaveAttach"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "SystemMaintenance.IncludeSlaveAttachLabel"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-checkbox",
                                      {
                                        on: {
                                          change:
                                            _vm.onBusinessIfVirtualBillAsAttachment
                                        },
                                        model: {
                                          value:
                                            _vm.emailEditing
                                              .businessIfVirtualBillAsAttachment,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.emailEditing,
                                              "businessIfVirtualBillAsAttachment",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "emailEditing.businessIfVirtualBillAsAttachment"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "SystemMaintenance.BusinessOrdersAttachments"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-checkbox",
                                      {
                                        model: {
                                          value:
                                            _vm.emailEditing
                                              .hblCfmStateOriginDraft,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.emailEditing,
                                              "hblCfmStateOriginDraft",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "emailEditing.hblCfmStateOriginDraft"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "SystemMaintenance.HblCfmStateOriginDraftLabel"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-checkbox",
                                      {
                                        on: {
                                          change: _vm.onHblBlWayAttachChange
                                        },
                                        model: {
                                          value:
                                            _vm.emailEditing.hblBlWayAttach,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.emailEditing,
                                              "hblBlWayAttach",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "emailEditing.hblBlWayAttach"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "SystemMaintenance.HblBlWayAttachLabel"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-checkbox",
                                      {
                                        model: {
                                          value:
                                            _vm.emailEditing
                                              .whenBillNotStartWithoutAttachment,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.emailEditing,
                                              "whenBillNotStartWithoutAttachment",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "emailEditing.whenBillNotStartWithoutAttachment"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "SystemMaintenance.BillNotStartNoneFile"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _vm.emailEditing.pushLink === "16"
                                      ? [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: { display: "flex" }
                                            },
                                            [
                                              _c("span", {
                                                staticClass: "edit-email-title",
                                                staticStyle: {
                                                  position: "unset",
                                                  "margin-top": "8px"
                                                }
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "padding-left": "5px"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "SystemMaintenance.FormalDivisionRule"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _c(
                                            "el-checkbox",
                                            {
                                              attrs: {
                                                disabled: !_vm.emailEditing
                                                  .businessIfVirtualBillAsAttachment
                                              },
                                              model: {
                                                value:
                                                  _vm.emailEditing
                                                    .businessIfVirtualBillOnlyAttachment,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.emailEditing,
                                                    "businessIfVirtualBillOnlyAttachment",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "emailEditing.businessIfVirtualBillOnlyAttachment"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "SystemMaintenance.BusinessIfVirtualBillOnlyAttachment"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      : _vm._e(),
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            width: "400px"
                                          }
                                        },
                                        [
                                          _c("span", {
                                            staticClass: "edit-email-title",
                                            staticStyle: {
                                              position: "unset",
                                              "margin-top": "8px"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "padding-left": "5px"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "SystemMaintenance.WhenIssuesBillOfExtracted"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-checkbox",
                                        {
                                          model: {
                                            value:
                                              _vm.emailEditing
                                                .takeWhenHasCustomerBillConfirm,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.emailEditing,
                                                "takeWhenHasCustomerBillConfirm",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "emailEditing.takeWhenHasCustomerBillConfirm"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "SystemMaintenance.WhenLadingHasBeenDocuments"
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-checkbox",
                                        {
                                          model: {
                                            value:
                                              _vm.emailEditing
                                                .takeWhenHasCustomerBillNotConfrim,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.emailEditing,
                                                "takeWhenHasCustomerBillNotConfrim",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "emailEditing.takeWhenHasCustomerBillNotConfrim"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "SystemMaintenance.WhenIsNeitherConfirmedExtracted"
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-checkbox",
                                        {
                                          model: {
                                            value:
                                              _vm.emailEditing
                                                .autoPrintWhenNoneCustomerBillConfirm,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.emailEditing,
                                                "autoPrintWhenNoneCustomerBillConfirm",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "emailEditing.autoPrintWhenNoneCustomerBillConfirm"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "SystemMaintenance.WhenOfLadingHasSample"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  ],
                                  2
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _vm.emailEditing.pushLink === "16"
                          ? _c(
                              "el-form-item",
                              {
                                staticStyle: { "margin-top": "-95px" },
                                attrs: { "label-width": "0" }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "margin-left": "50px",
                                      color: "black"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "SystemMaintenance.LockAfterSend"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "el-checkbox",
                                  {
                                    model: {
                                      value:
                                        _vm.emailEditing
                                          .sendLockSlaveHblAndVirtualBill,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.emailEditing,
                                          "sendLockSlaveHblAndVirtualBill",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "emailEditing.sendLockSlaveHblAndVirtualBill"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "SystemMaintenance.SendLockSlaveHblAndVirtualBill"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.emailEditing.pushLink === "17"
                          ? _c(
                              "el-form-item",
                              {
                                staticStyle: { "margin-top": "-95px" },
                                attrs: { "label-width": "0" }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "margin-left": "50px",
                                      color: "black"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "SystemMaintenance.LockAfterSend"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "el-checkbox",
                                  {
                                    model: {
                                      value:
                                        _vm.emailEditing
                                          .sendLockExchangeAgentHblAndVirtualBill,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.emailEditing,
                                          "sendLockExchangeAgentHblAndVirtualBill",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "emailEditing.sendLockExchangeAgentHblAndVirtualBill"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "SystemMaintenance.SendLockExchangeAgentHblAndVirtualBill"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _c("el-form-item", [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "margin-top": "35px",
                                display: "flex"
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-warning",
                                staticStyle: {
                                  color: "#E6A23C",
                                  "font-size": "14px",
                                  "margin-right": "5px",
                                  "line-height": "18px"
                                }
                              }),
                              _c(
                                "span",
                                { staticStyle: { "line-height": "18px" } },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "SystemMaintenance.FileAttachmentTip"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      ]
                    : _vm._e(),
                  _vm.isBbSendDestinationPortAgent
                    ? [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("SystemMaintenance.AttachmentItems")
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "start"
                                }
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: {
                                      width: "100px",
                                      "margin-right": "10px",
                                      "border-radius": "5px"
                                    },
                                    attrs: {
                                      no: "SelectFileType",
                                      type: "primary"
                                    },
                                    on: { click: _vm.onSelectFileType }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "SystemMaintenance.SelectFileType"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c("el-input", {
                                  staticStyle: {
                                    width: "320px",
                                    "margin-right": "10px"
                                  },
                                  attrs: {
                                    no: "fileCategoryLabel",
                                    value: _vm.fileCategoryLabel,
                                    disabled: "",
                                    type: "textarea",
                                    rows: 3
                                  }
                                }),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "150px",
                                      "margin-top": "-7px"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-checkbox",
                                      {
                                        staticStyle: { "margin-top": "-7px" },
                                        attrs: {
                                          no: "hblWithoutGenerateAttach"
                                        },
                                        on: {
                                          change:
                                            _vm.onHblWithoutGenerateAttachChange
                                        },
                                        model: {
                                          value:
                                            _vm.emailEditing
                                              .hblWithoutGenerateAttach,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.emailEditing,
                                              "hblWithoutGenerateAttach",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "emailEditing.hblWithoutGenerateAttach"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "SystemMaintenance.HblWithoutGenerateAttachLabel"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-checkbox",
                                      {
                                        staticStyle: { "margin-top": "-7px" },
                                        attrs: { no: "confirmedPrintHbl" },
                                        model: {
                                          value:
                                            _vm.emailEditing.confirmedPrintHbl,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.emailEditing,
                                              "confirmedPrintHbl",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "emailEditing.confirmedPrintHbl"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "SystemMaintenance.ConfirmedPrintHblLabel"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    [
                                      _c(
                                        "div",
                                        { staticStyle: { display: "flex" } },
                                        [
                                          _c("span", {
                                            staticClass: "edit-email-title",
                                            staticStyle: {
                                              left: "unset",
                                              top: "55px"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "padding-left": "10px"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "SystemMaintenance.EmailAttachRule"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-checkbox",
                                        {
                                          attrs: {
                                            no: "hblCfmStateOriginDraft"
                                          },
                                          model: {
                                            value:
                                              _vm.emailEditing
                                                .hblCfmStateOriginDraft,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.emailEditing,
                                                "hblCfmStateOriginDraft",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "emailEditing.hblCfmStateOriginDraft"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "SystemMaintenance.HblCfmStateOriginDraftLabel"
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-checkbox",
                                        {
                                          attrs: { no: "hblBlWayAttach" },
                                          on: {
                                            change: _vm.onHblBlWayAttachChange
                                          },
                                          model: {
                                            value:
                                              _vm.emailEditing.hblBlWayAttach,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.emailEditing,
                                                "hblBlWayAttach",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "emailEditing.hblBlWayAttach"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "SystemMaintenance.HblBlWayAttachLabel"
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-checkbox",
                                        {
                                          attrs: {
                                            no:
                                              "whenBillNotStartWithoutAttachment"
                                          },
                                          model: {
                                            value:
                                              _vm.emailEditing
                                                .whenBillNotStartWithoutAttachment,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.emailEditing,
                                                "whenBillNotStartWithoutAttachment",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "emailEditing.whenBillNotStartWithoutAttachment"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "SystemMaintenance.BillNotStartNoneFile"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            width: "400px"
                                          }
                                        },
                                        [
                                          _c("span", {
                                            staticClass: "edit-email-title",
                                            staticStyle: {
                                              position: "unset",
                                              "margin-top": "8px"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "padding-left": "5px"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "SystemMaintenance.WhenIssuesBillOfExtracted"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-checkbox",
                                        {
                                          model: {
                                            value:
                                              _vm.emailEditing
                                                .takeWhenHasCustomerBillConfirm,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.emailEditing,
                                                "takeWhenHasCustomerBillConfirm",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "emailEditing.takeWhenHasCustomerBillConfirm"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "SystemMaintenance.WhenLadingHasBeenDocuments"
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-checkbox",
                                        {
                                          model: {
                                            value:
                                              _vm.emailEditing
                                                .takeWhenHasCustomerBillNotConfrim,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.emailEditing,
                                                "takeWhenHasCustomerBillNotConfrim",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "emailEditing.takeWhenHasCustomerBillNotConfrim"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "SystemMaintenance.WhenIsNeitherConfirmedExtracted"
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-checkbox",
                                        {
                                          model: {
                                            value:
                                              _vm.emailEditing
                                                .autoPrintWhenNoneCustomerBillConfirm,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.emailEditing,
                                                "autoPrintWhenNoneCustomerBillConfirm",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "emailEditing.autoPrintWhenNoneCustomerBillConfirm"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "SystemMaintenance.WhenOfLadingHasSample"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  ],
                                  2
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticStyle: {
                              "margin-top": "-95px",
                              height: "100px"
                            },
                            attrs: { "label-width": "0" }
                          },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "margin-left": "50px",
                                  color: "black"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SystemMaintenance.LockAfterSend")
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                attrs: { no: "sendLockHblAndVirtualBill" },
                                model: {
                                  value:
                                    _vm.emailEditing.sendLockHblAndVirtualBill,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.emailEditing,
                                      "sendLockHblAndVirtualBill",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "emailEditing.sendLockHblAndVirtualBill"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "SystemMaintenance.SendLockHblAndVirtualBill"
                                    )
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    : _vm._e()
                ],
                2
              )
            ]
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.determine } },
                [_vm._v(_vm._s(_vm.$t("SystemMaintenance.OK")))]
              ),
              _c(
                "el-button",
                { attrs: { plain: "" }, on: { click: _vm.cancel } },
                [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Cancel")))]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.sendTest } },
                [_vm._v(_vm._s(_vm.$t("SystemMaintenance.SendTest")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.secondaryConfirmation,
            "close-on-click-modal": false,
            title: _vm.Title,
            width: "350px"
          },
          on: {
            "update:visible": function($event) {
              _vm.secondaryConfirmation = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.Title === "提示",
                  expression: "Title === '提示'"
                }
              ]
            },
            [_vm._v(_vm._s(_vm.dialogContent.text))]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.Title === "发送测试",
                  expression: "Title === '发送测试'"
                }
              ],
              staticStyle: {
                isplay: "flex",
                "align-items": "center",
                "justify-content": "center"
              }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "100px" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SystemMaintenance.SendTo") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        model: {
                          value: _vm.sendTestVal,
                          callback: function($$v) {
                            _vm.sendTestVal = $$v
                          },
                          expression: "sendTestVal"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SystemMaintenance.SendEmail"),
                        inline: true
                      }
                    },
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          on: {
                            change: function($event) {
                              return _vm.statusChange()
                            }
                          },
                          model: {
                            value: _vm.checkList,
                            callback: function($$v) {
                              _vm.checkList = $$v
                            },
                            expression: "checkList"
                          }
                        },
                        _vm._l(_vm.sendEamilArr, function(item, index) {
                          return _c(
                            "div",
                            { key: index },
                            [_c("el-checkbox", { attrs: { label: item } })],
                            1
                          )
                        }),
                        0
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.againDetermine }
                },
                [_vm._v(_vm._s(_vm.$t("SystemMaintenance.OK")))]
              ),
              _c(
                "el-button",
                { attrs: { plain: "" }, on: { click: _vm.confirmAgain } },
                [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _vm.fileTypeEditor.visible
        ? _c("mx-file-type-editor", {
            attrs: {
              visible: _vm.fileTypeEditor.visible,
              lob: _vm.emailEditing.lob,
              "file-id": _vm.fileTypeEditor.fileId,
              "file-category": _vm.fileTypeEditor.fileCategory
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.fileTypeEditor, "visible", $event)
              },
              saveFileType: _vm.onSaveFileType
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }